import { useId, useState } from 'react';
import { PLANT_CATALOG, PLANT_CATEGORIES } from '../lib/data';
import { candidateCommonName, candidateSpeciesKey, candidateCategory, correctCandidateSpecies } from '../lib/plantIdentity';
import { pickerCatalog, speciesVarieties } from '../lib/plantPicker';
import presets from '../data/legacyVarietyPresets.json';
import { useI18n } from '../i18n';
import PlantVarietyPicker from './PlantVarietyPicker';
import PlantIdentityPath from './PlantIdentityPath';

export default function PlantCandidateEditor({ candidate, onChange, varietyCatalog }) {
  const { t, locale } = useI18n();
  const listId = useId();
  const [own, setOwn] = useState(false);
  const category = candidateCategory(candidate);
  const name = candidateCommonName(candidate);
  const key = candidateSpeciesKey(candidate);
  return <div className="space-y-3" data-testid="candidate-identity-editor">
    <PlantIdentityPath category={category ? t(`plant_picker.category_${category}`) : ''} species={name} variety={candidate.variety} />
    <label className="block text-sm">{t('plant_picker.personal_name')}
      <input data-testid="candidate-personal-name" maxLength={160} className="mt-1 w-full rounded-xl border border-brand-border bg-brand-bg2 px-3 py-2" value={candidate.display_name ?? candidate.name ?? ''}
        onChange={e => onChange({ name: e.target.value, display_name: e.target.value })} />
    </label>
    <label className="block text-sm">{t('plant_picker.choose_category')}
      <select data-testid="candidate-category" className="mt-1 w-full rounded-xl border border-brand-border bg-brand-bg2 px-3 py-2" value={category}
        onChange={e => { setOwn(false); onChange(correctCandidateSpecies(candidate, '', e.target.value)); }}>
        <option value="">{t('plant_picker.choose_category')}</option>
        {[...PLANT_CATEGORIES.filter(c => c.id !== 'all').map(c => c.id), 'other'].map(id => <option key={id} value={id}>{t(`plant_picker.category_${id}`)}</option>)}
      </select>
    </label>
    <label className="block text-sm">{t('plant_picker.choose_species')}
      <input data-testid="candidate-species" list={listId} value={name} maxLength={160} className="mt-1 w-full rounded-xl border border-brand-border bg-brand-bg2 px-3 py-2"
        onChange={e => { setOwn(false); onChange(correctCandidateSpecies(candidate, e.target.value, category)); }} />
      <datalist id={listId}>{pickerCatalog(PLANT_CATALOG, { category: category || 'all' }).map(p => <option key={p.id} value={p.name[locale] || p.name.en || p.name.da}>{p.scientific_name}</option>)}</datalist>
    </label>
    <PlantVarietyPicker key={key} speciesLabel={name} options={speciesVarieties(key, varietyCatalog, presets)} value={candidate.variety || ''}
      onChange={variety => onChange({ variety })} addingOwn={own} setAddingOwn={setOwn} />
    {!name.trim() && <p role="status" className="text-sm">{t('plant_picker.identity_required')}</p>}
    {category === 'mushroom' && <p className="text-sm p-3 rounded-xl bg-amber-50 text-amber-950">{t('plant_picker.mushroom_caution')}</p>}
  </div>;
}
